import http from '@/http'
import createCrudModule from 'vuex-crud'
import { filter } from 'lodash'

export default createCrudModule({
  client: http,
  resource: 'admin/departments',
  urlRoot: 'admin/departments',

  state: {
    total: 0
  },

  getters: {
    byOfficeId: state => id => {
      return filter(state.entities, {
        office_id: +id
      })
    }
  },

  parseList(response) {
    return Object.assign({}, response, {
      data: response.data.data,
      total: response.data.total
    })
  },

  onFetchListSuccess(state, response) {
    state.total = response.total
  }
})
